import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { IUserUpdate } from '../../models/account/user-update';
import { IUpdateUserResult } from '../../models/account/user-update-result';
import { SettingsService } from 'app/services/core/settings.service';
import { SharedService } from '@shared/services/shared.service';
import { AccountService } from 'app/services/account/account.service';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.scss']
})
export class UpdateUserComponent implements OnInit {

  updateForm = new UntypedFormGroup({
    login: new UntypedFormControl({ value: null, disabled: true }),
    email: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, Validators.email]),
    company: new UntypedFormControl({ value: null, disabled: true }),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(8),
      UpdateUserComponent.passwordCriteria()]),
    confirmPassword: new UntypedFormControl(''),
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    address: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    state: new UntypedFormControl(''),
    zip: new UntypedFormControl('', Validators.pattern(/^\d{5}(-\d{4})?$/)),
    phone: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4}).*$/)]),
    registrationDate: new UntypedFormControl({ value: null, disabled: true })
  }, { validators: this.passwordsMatch() });

  updateComplete: boolean = false;
  userUpdateResult: IUpdateUserResult = {
    duplicate: false,
    updated: true,
    user: null
  };

  states: string[] = [];
  user: IUserUpdate;

  constructor(public settings: SettingsService,
    private sharedService: SharedService, 
    private accountService: AccountService) { }

  static passwordCriteria(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let hasNumber = /\d/.test(control.value);
      let hasUpper = /[A-Z]/.test(control.value);
      let hasLower = /[a-z]/.test(control.value);
      let hasSpecial = /[$@$!%*?&]/.test(control.value);
      return hasNumber && hasUpper && hasLower && hasSpecial ? null : { criteria: true };
    };
  }

  passwordsMatch(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const password = control.value.password;
      const confirmPassword = control.value.confirmPassword;
      return password === confirmPassword ? null : { mismatch: true };
    };
  }

  ngOnInit(): void {
    this.states = this.sharedService.states;
    this.accountService.getAppUser().subscribe(
      (response) => this.user = response,
      (error) => console.log('error', error),
      () => {
        this.updateForm.patchValue({
          login: this.user.loginName,
          email: this.user.email,
          company: this.user.companyName,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          address: this.user.address,
          city: this.user.city,
          state: this.user.state,
          zip: this.user.zipCode,
          phone: this.user.phone,
          registrationDate: this.user.registrationDate
        });
      }
    );
  }

  validatePasswordsMatch(): boolean {
    if (this.updateForm.hasError('mismatch') && this.updateForm.get('confirmPassword').touched) {
      this.updateForm.get('confirmPassword').setErrors(['mismatch']);
      return true;
    }
    this.updateForm.get('confirmPassword').clearValidators();
    this.updateForm.get('confirmPassword').updateValueAndValidity();
    return false;
  }

  update(): void {
    let form = this.updateForm.value;
    let updateUser: IUserUpdate = {
      registrationId: this.user.registrationId,
      loginName: this.user.loginName,
      email: this.user.email,
      companyName: this.user.companyName,
      password: form.password,
      firstName: form.firstName,
      lastName: form.lastName,
      address: form.address,
      city: form.city,
      state: form.state,
      zipCode: form.zip,
      phone: form.phone,
      registrationDate: this.user.registrationDate,
      adminEmailOnly: this.user.adminEmailOnly,
      inspector: this.user.inspector,
      orPNumber: this.user.orPNumber,
      status: this.user.status,
      teamLead: this.user.teamLead,
      administrator: this.user.administrator
    }
    this.accountService.updateAppUser(updateUser).subscribe(
      response => this.userUpdateResult = response,
      error => console.log('error', error),
      () => {
        this.updateComplete = true;
        if (this.userUpdateResult.updated) {
          this.updateUser(updateUser);
        }
      }
    );
  }

  updateUser(user: IUserUpdate) {
    this.updateForm.patchValue({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      address: user.address,
      city: user.city,
      state: user.state,
      zip: user.zipCode,
      phone: user.phone
    });
  }
}
